export { Hashtag as default } from './Hashtag';
